import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { canaisMidiasSociais } from '../../../../home/common/canal-midia-social/canal-midia-social';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-canal-midia-social-multi-select',
  templateUrl: './novo-canal-midia-social-multi-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoCanalMidiaSocialMultiSelectComponent),
      multi: true
    }
  ]
})
export class NovoCanalMidiaSocialMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() idsCanaisMidiasSociais: number[] = [];
  @Input() variante: 'filtro' | undefined;
  @Input() settings: Partial<IMultiSelectSettings> = {};

  @Output() changed = new EventEmitter<number[]>();

  options: IOption[] = [];
  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Selecione os canais de mídias sociais',
    singular: 'Canais de Mídia Social',
    plural: 'Canais de Mídias Sociais',
    searchEmptyResultMessage: 'Nenhum canal de mídia social encontrado',
    showFooter: false
  };

  ngOnInit() {
    this.settings = { ...this.defaultSettings, ...this.settings };
    this.create();
  }

  private create() {
    this.options = [
      ...[{
        id: 0,
        label: 'SEM CANAL',
        isChecked: false
      }],
      ...canaisMidiasSociais.map(canal => ({
        id: canal.id,
        label: canal.nome,
        isChecked: false
      }))
    ];
  }

  protected updateValue(newValue: number[] | null): void {
    this.idsCanaisMidiasSociais = newValue || [];
  }

  onSelectionChange(): void {
    this.emitChange(this.idsCanaisMidiasSociais);
  }

  onSearch(): void {
    this.changed.emit(this.idsCanaisMidiasSociais);
  }
}
